const doc = [({"en":({"adminComponentAdminTop":({"firstHotelRegistrationMessage":"Please register your facility. You can register {{num}} facilities."})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;